import { useRef, useEffect } from "react"
import type { BaseRecord, GetKeyFn, TableProps } from "./types"
import { getHeaderGroups, getDataColumns, indexBy } from "./utils"
import { useUpdateData, useUpdateColumns } from "./atoms"
import { useCellStore } from "./TableScope"

export function useTable<R extends BaseRecord>(
  props: Pick<TableProps<R>, "columns" | "data" | "getRowKey">,
) {
  const { columns, data, getRowKey } = props
  const cells = useCellStore()
  const setConfig = cells.setCellConfig

  // data
  const setData = useUpdateData<R>()
  const getKeyRef = useRef(getRowKey)
  getKeyRef.current = getRowKey

  useEffect(() => {
    const k = getKeyRef.current as GetKeyFn<R>
    const { records } = indexBy(data, k)
    setData(records)
  }, [data, setData])

  //columns
  const headerGroups = getHeaderGroups(columns)
  const updateColumns = useUpdateColumns()
  useEffect(() => {
    const dataColumns = getDataColumns(columns)
    dataColumns.forEach((col) => {
      if (!col.cell || col.cell.type === "display") return
      setConfig(col.id, col.cell)
    })
    updateColumns(dataColumns)
  }, [columns, updateColumns, setConfig])

  return { headerGroups }
}
